import { get } from 'lodash';
import { SECTION_CATEGORY, SECTION_HOMEPAGE, SECTION_MY_POSTS, SECTION_POST_LIST, SECTION_RELATED_POSTS, } from './sections';
import { IS_VIEW_COUNT_ENABLED, IS_COMMENT_COUNT_ENABLED, IS_LIKE_COUNT_ENABLED, IS_AUTHOR_NAME_ENABLED, IS_AUTHOR_BADGE_ENABLED, IS_AUTHOR_PICTURE_ENABLED, IS_POST_UPDATED_DATE_ENABLED, IS_CATEGORY_LABELS_ENABLED, IS_POST_TITLE_ENABLED, IS_POST_PUBLISH_DATE_ENABLED, IS_READING_TIME_ENABLED, IS_MORE_OPTIONS_MENU_ENABLED, IS_POST_DESCRIPTION_ENABLED, IS_TAGS_ENABLED, IS_POST_DATE_ENABLED, IS_CATEGORY_LABEL_ENABLED, IS_COVER_IMAGE_ENABLED, AUTHOR_INFO_TYPE, AUTHOR_INFO_TYPE_NAME_PICTURE, IS_POST_RATING_ENABLED, } from './wix-params';
const FEED_METADATA_SETTINGS = {
    [IS_VIEW_COUNT_ENABLED]: true,
    [IS_COMMENT_COUNT_ENABLED]: true,
    [IS_LIKE_COUNT_ENABLED]: true,
    [IS_CATEGORY_LABEL_ENABLED]: false,
    [IS_TAGS_ENABLED]: true,
    [IS_POST_DESCRIPTION_ENABLED]: true,
    [IS_POST_TITLE_ENABLED]: true,
    [IS_MORE_OPTIONS_MENU_ENABLED]: true,
    [IS_CATEGORY_LABELS_ENABLED]: true,
    [IS_POST_UPDATED_DATE_ENABLED]: true,
    [IS_POST_DATE_ENABLED]: true,
    [IS_POST_PUBLISH_DATE_ENABLED]: true,
    [IS_READING_TIME_ENABLED]: true,
    [IS_AUTHOR_PICTURE_ENABLED]: true,
    [IS_AUTHOR_NAME_ENABLED]: true,
    [IS_AUTHOR_BADGE_ENABLED]: true,
    [IS_COVER_IMAGE_ENABLED]: true,
    [IS_POST_RATING_ENABLED]: true,
    [AUTHOR_INFO_TYPE]: AUTHOR_INFO_TYPE_NAME_PICTURE,
};
const FEED_METADATA_SETTINGS_MY_POSTS = {
    [IS_VIEW_COUNT_ENABLED]: false,
    [IS_COMMENT_COUNT_ENABLED]: false,
    [IS_LIKE_COUNT_ENABLED]: false,
    [IS_CATEGORY_LABEL_ENABLED]: false,
    [IS_TAGS_ENABLED]: false,
    [IS_POST_DESCRIPTION_ENABLED]: false,
    [IS_POST_TITLE_ENABLED]: true,
    [IS_MORE_OPTIONS_MENU_ENABLED]: true,
    [IS_CATEGORY_LABELS_ENABLED]: false,
    [IS_POST_UPDATED_DATE_ENABLED]: true,
    [IS_POST_PUBLISH_DATE_ENABLED]: true,
    [IS_POST_DATE_ENABLED]: false,
    [IS_READING_TIME_ENABLED]: false,
    [IS_AUTHOR_PICTURE_ENABLED]: false,
    [IS_AUTHOR_NAME_ENABLED]: false,
    [IS_AUTHOR_BADGE_ENABLED]: false,
    [IS_COVER_IMAGE_ENABLED]: true,
    [IS_POST_RATING_ENABLED]: true,
    [AUTHOR_INFO_TYPE]: AUTHOR_INFO_TYPE_NAME_PICTURE,
};
const FEED_METADATA_SETTINGS_RELATED_POSTS = {
    [IS_VIEW_COUNT_ENABLED]: false,
    [IS_COMMENT_COUNT_ENABLED]: false,
    [IS_LIKE_COUNT_ENABLED]: false,
    [IS_CATEGORY_LABEL_ENABLED]: false,
    [IS_TAGS_ENABLED]: false,
    [IS_POST_DESCRIPTION_ENABLED]: false,
    [IS_POST_TITLE_ENABLED]: true,
    [IS_MORE_OPTIONS_MENU_ENABLED]: false,
    [IS_CATEGORY_LABELS_ENABLED]: false,
    [IS_POST_UPDATED_DATE_ENABLED]: false,
    [IS_POST_DATE_ENABLED]: false,
    [IS_POST_PUBLISH_DATE_ENABLED]: false,
    [IS_READING_TIME_ENABLED]: false,
    [IS_AUTHOR_PICTURE_ENABLED]: false,
    [IS_AUTHOR_NAME_ENABLED]: false,
    [IS_AUTHOR_BADGE_ENABLED]: false,
    [IS_COVER_IMAGE_ENABLED]: true,
    [IS_POST_RATING_ENABLED]: false,
    [AUTHOR_INFO_TYPE]: AUTHOR_INFO_TYPE_NAME_PICTURE,
};
const FEED_METADATA_SETTINGS_BY_SECTION = {
    [SECTION_HOMEPAGE]: FEED_METADATA_SETTINGS,
    [SECTION_CATEGORY]: FEED_METADATA_SETTINGS,
    [SECTION_POST_LIST]: FEED_METADATA_SETTINGS,
    [SECTION_RELATED_POSTS]: FEED_METADATA_SETTINGS_RELATED_POSTS,
    [SECTION_MY_POSTS]: FEED_METADATA_SETTINGS_MY_POSTS,
};
export const getFeedMetadataSettingsDefaultValue = (wixParam, section = SECTION_HOMEPAGE) => get(FEED_METADATA_SETTINGS_BY_SECTION, [section, wixParam]);
//# sourceMappingURL=feed-metadata-settings.js.map